// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"ddbbeda3","223":"e2ee7caf"}[chunkId] + ".chunk.js";
};